import { render, staticRenderFns } from "./GameBroken.vue?vue&type=template&id=983776be&"
import script from "./GameBroken.vue?vue&type=script&lang=ts&"
export * from "./GameBroken.vue?vue&type=script&lang=ts&"
import style0 from "./GameBroken.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports